export const STORY_FIELDS = [
  { value: 'author_username', label: 'Author Username' },
  { value: 'page_name', label: 'Page Name' },
];

export const GEO_LOGIC = 'source_default_location';
export const RESOLUTION_CITY = 5;

// Lat/Lon bounds per Util.GeoHelper.validateLocationGeo (coffee/helpers/geo.coffee).
export const LAT_MIN = -90;
export const LAT_MAX = 90;
export const LON_MIN = -180;
export const LON_MAX = 180;

export const LATLONG_WARNING =
  'Use only city, region, or approved place centroids. ' +
  'Do not enter precise locations tied to a person or individual username/account.';

// PATCH /defaults/{id} accepts only the location dictionary (per Carmen
// PatchDefaultLocationRequest). term/platform/story_field/logic are not
// patchable; spreading the whole Geo object would leak confidence/
// precision/source onto the wire.
const PATCHABLE_GEO_FIELDS = [
  'country', 'country_iso', 'subdivision', 'county', 'city', 'district',
  'street', 'address', 'postcode', 'latlong', 'location',
];

export const buildPatchBody = (geo) => {
  const body = {};
  PATCHABLE_GEO_FIELDS.forEach((k) => {
    if (geo[k] !== undefined) {body[k] = geo[k];}
  });
  body.resolution = RESOLUTION_CITY;
  return body;
};
